import { useTranslation } from 'react-i18next';
import type { TwoFactorIdentityConfirmationEnableModalArgs } from '../model';
import { ModalComponentWrapper } from '@/shared/components';
import { MfaConfirmationScreen } from '@/entities/mfa-identity';
import { useTwoFactorIdentityEnableForm } from '../model/useTwoFactorIdentityEnableForm';
import { sendTwoFactorIdentityCode } from '../api/requests';
import { useMemo, useState } from 'react';
import { MFA_IDENTITY_TYPES } from '@/entities/mfa-identity';

const TwoFactorIdentityEnableFormModal = ({
  identityType,
  appKey,
  identity,
  onBack,
  onSuccess,
}: TwoFactorIdentityConfirmationEnableModalArgs) => {
  const { t } = useTranslation();
  const localePath = 'authPages.identityConfirmationForm';
  const [maskedContact, setMaskedContact] = useState('');

  const {
    enableForm,
    isEnableTwoFactorLoading,
    enableTwoFactorSubmit,
    enableTwoFactorError,
  } = useTwoFactorIdentityEnableForm({
    identityType,
    appKey,
    identity,
    onSuccess,
  });

  const descriptionText = useMemo(() => {
    if (identityType === MFA_IDENTITY_TYPES.GOOGLE_AUTHENTICATOR) {
      return t(`${localePath}.appDescription`);
    }
    return maskedContact
      ? t(`${localePath}.description`) + ' ' + maskedContact
      : '';
  }, [identityType, t, localePath, maskedContact]);

  return (
    <ModalComponentWrapper
      title={t(`${localePath}.title`)}
      description={descriptionText}
      onBack={onBack}>
      <MfaConfirmationScreen
        form={enableForm}
        identityType={identityType}
        mfaCodeFieldName="code"
        sendOtpCodeMutationFn={sendTwoFactorIdentityCode}
        setMaskedContact={setMaskedContact}
        onSubmit={enableTwoFactorSubmit}
        isSubmitLoading={isEnableTwoFactorLoading}
        submitError={enableTwoFactorError?.message}
        isInitialSetup
      />
    </ModalComponentWrapper>
  );
};

export { TwoFactorIdentityEnableFormModal };
